import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ApiIcon extends BaseIcon {
    getChildren = () => [
        <g fill={this.getColor()} >
            <ellipse cx="8.5" cy="2" rx="1.5" ry="1"/>
            <ellipse cx="8.5" cy="5" rx="1.5" ry="1"/>
            <ellipse cx="13.5" cy="4" rx="1.5" ry="1"/>
            <ellipse cx="3.5" cy="4" rx="1.5" ry="1"/>
            <polygon points="8,16 1,14 1,5 8,7 "/>
            <polygon points="9,16 16,14 16,5 9,7 "/>
        </g>
    ]
    getViewBox = () => '0 0 16 16'
}
